import { Redirect } from "wouter";

export default function SettlementTerms() {
  return <Redirect to="/legal?document=settlement-terms" replace />;
}
